export default {
  setPostingGroups: (state, postingGroups) => { state.postingGroups = postingGroups },
  setPostBatches: (state, postBatches) => { state.postBatches = postBatches }
}
